import { ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { LoaderComponent } from '../../loader/loader.component';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  imports: [FooterComponent, LoaderComponent, RouterOutlet, HeaderComponent, BreadcrumbComponent],
})
export class ContentLayoutComponent implements OnInit, OnDestroy {
  isHomeRoute = false;
  private routerEventsSub?: Subscription;

  constructor(
    private viewportScroller: ViewportScroller,
    private router: Router,
  ) {}

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.updateRouteState(this.router.url);
    this.routerEventsSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateRouteState(event.urlAfterRedirects);
      }
    });
  }

  toggleSwitcherBody() {}

  scrolled: boolean = false;

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
  }

  private updateRouteState(url: string): void {
    this.isHomeRoute = this.normalizeUrl(url) === '/';
  }

  private normalizeUrl(url: string): string {
    if (!url) {
      return '/';
    }
    const sanitized = url.split('#')[0]?.split('?')[0];
    return sanitized && sanitized.trim().length ? sanitized : '/';
  }
}
